import { Epic } from 'redux-observable';
import { catchError, map, switchMap } from 'rxjs/operators';
import { ofType } from '@alycecom/utils';

import {
  loadRequiredActionsRequest,
  loadRequiredActionsSuccess,
  loadRequiredActionsFail,
  validateProspectsRequest,
  validateProspectsSuccess,
  validateProspectsFail,
} from './requiredActions.actions';
import { IRequiredAction } from './requiredActions.types';

export const loadRequiredActionsEpic: Epic = (action$, state$, { apiService, messagesService: { errorHandler } }) =>
  action$.pipe(
    ofType(loadRequiredActionsRequest),
    switchMap(({ payload: { hashId } }) =>
      apiService.get(`/api/recipient/${hashId}/actions`).pipe(
        map((response: IRequiredAction[]) => loadRequiredActionsSuccess(response)),
        catchError(errorHandler({ callbacks: loadRequiredActionsFail })),
      ),
    ),
  );

export const validateProspectsEpic: Epic = (action$, state$, { apiService, messagesService: { errorHandler } }) =>
  action$.pipe(
    ofType(validateProspectsRequest),
    switchMap(({ payload: { hashId, prospects } }) =>
      apiService.post(`/api/recipient/${hashId}/validate/actions`, { body: { prospects } }).pipe(
        map(() => validateProspectsSuccess(prospects)),
        catchError(errorHandler({ callbacks: validateProspectsFail })),
      ),
    ),
  );

export const actionsEpics = [loadRequiredActionsEpic, validateProspectsEpic];
